import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnDestroy,
  Optional,
  Self,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, NgControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-contact-method-control',
    templateUrl: './contact-method-control.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ContactMethodControlComponent),
            multi: true
        }
    ],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput]
})
export class ContactMethodControlComponent
  implements ControlValueAccessor, OnDestroy, AfterViewInit
{
  form = new FormGroup({
    type: new FormControl<'email' | 'phone'>('email'),
    value: new FormControl<string>('', Validators.required)
  });

  onChange: any = () => {};
  onTouch: any = () => {};
  ngUnsubscribe = new Subject<void>();

  disabled = false;

  constructor(private injector: Injector) {}

  ngAfterViewInit(): void {
    const control = this.injector.get(NgControl);
    this.form.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value) => {
        // hack needed to get the parent form control and update the value that way, as onChange wasn't reflecting in the parent form
        control.control.setValue(value);
      });
    control.control.setValidators(({ value }) => {
      if (!value.value) {
        return { required: true };
      }
      return null;
    });
    control.control.updateValueAndValidity();
  }

  writeValue(obj: any): void {
    if (obj.type) {
      this.form.patchValue({ type: obj.type }, { emitEvent: false });
    }
    if (obj.value) {
      this.form.patchValue({ value: obj.value }, { emitEvent: false });
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onChange = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
